import React, { useState } from 'react';
import './DedicatedIran.css';

const DedicatedIran = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'شروع',
      price: '۷۵۰',
      unit: 'هزار تومان / ماه',
      cpu: 'Intel Xeon E3',
      ram: '16 GB',
      storage: '2x240 GB SSD',
      features: ['لوکیشن ایران', 'پینگ فوق‌العاده', 'پشتیبانی ۲۴/۷', 'SLA 99.9%'],
      popular: false,
    },
    {
      tier: 'پیشرفته',
      price: '۱,۳۵۰',
      unit: 'هزار تومان / ماه',
      cpu: 'Intel Xeon E5',
      ram: '32 GB',
      storage: '2x480 GB SSD',
      features: ['لوکیشن ایران', 'پینگ فوق‌العاده', 'پشتیبانی ۲۴/۷', 'SLA 99.9%', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: 'حرفه‌ای',
      price: '۲,۲۰۰',
      unit: 'هزار تومان / ماه',
      cpu: 'Intel Xeon Gold',
      ram: '64 GB',
      storage: '2x960 GB NVMe',
      features: ['لوکیشن ایران', 'پینگ فوق‌العاده', 'پشتیبانی ۲۴/۷', 'SLA 99.9%', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>سرور اختصاصی ایران | خرید سرور اختصاصی ایران با بهترین قیمت | افراسل</h1>
        <p>خرید سرور اختصاصی ایران با پینگ فوق‌العاده، بهترین قیمت و پشتیبانی ۲۴ ساعته.</p>
        <meta name="description" content="خرید سرور اختصاصی ایران با بهترین قیمت از افراسل. سرور اختصاصی ایران با پینگ فوق‌العاده، قیمت مناسب و پشتیبانی ۲۴/۷." />
      </div>

      <section className="dedicatediran-hero">
        <div className="dedicatediran-hero-bg"></div>
        <div className="wrap">
          <div className="dedicatediran-hero-content">
            <div className="dedicatediran-badge">
              <span className="pulse-dot"></span>
              🇮🇷 سرور اختصاصی ایران
            </div>
            <h1 className="dedicatediran-hero-title">
              سرور اختصاصی <em>ایران</em>
            </h1>
            <p className="dedicatediran-hero-desc">
              سرور اختصاصی ایران با پینگ فوق‌العاده برای کاربران داخلی و بهترین قیمت.
              مناسب برای وب‌سایت‌های پربازدید و کسب‌وکارهای ایرانی.
            </p>
            <div className="dedicatediran-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">ایران</span>
                <span className="stat-label">لوکیشن</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="dedicatediran-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های سرور اختصاصی ایران</span>
            <h2 className="sec-h">پلن <em>مناسب</em> کسب‌وکار خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع سرور اختصاصی ایران با قیمت‌های رقابتی.</p>
          </div>
          <div className="dedicatediran-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`dedicatediran-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="dedicatediran-popular-badge">پرفروش‌ترین</span>}
                <div className="dedicatediran-plan-tier">{plan.tier}</div>
                <div className="dedicatediran-plan-price">
                  <span className="dedicatediran-plan-num">{plan.price}</span>
                  <span className="dedicatediran-plan-unit">{plan.unit}</span>
                </div>
                <div className="dedicatediran-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                </div>
                <ul className="dedicatediran-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="dedicatediran-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="dedicatediran-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              سرور اختصاصی <em>ایران</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید سرور اختصاصی ایران، از پینگ فوق‌العاده، قیمت مناسب و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید سرور</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DedicatedIran;
